'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var SecondaryButton = require('../../components/SecondaryButton.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var PackageRemoveConfirmationProvider = require('./PackageRemoveConfirmationProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Spacer = styled__default["default"].div.withConfig({
  componentId: "sc-1bqveh5-0"
})(["padding-bottom:1rem;"]);
const PackageRemoveConfirmationForm = () => {
  const {
    claimsRemovePackageOptionYes,
    claimsRemovePackageOptionNo
  } = nthHookTranslations.useTranslations();
  const {
    state,
    setState
  } = PackageRemoveConfirmationProvider.usePackageRemoveConfirmation();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: () => setState('yes'),
    selected: state === 'yes'
  }, claimsRemovePackageOptionYes), /*#__PURE__*/React__default["default"].createElement(Spacer, null), /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: () => setState('no'),
    selected: state === 'no'
  }, claimsRemovePackageOptionNo));
};
var PackageRemoveConfirmationForm$1 = nthHookTranslations.withTranslationsProvider(PackageRemoveConfirmationForm, {
  translationKeys: ['claimsRemovePackageOptionYes', 'claimsRemovePackageOptionNo']
});

exports["default"] = PackageRemoveConfirmationForm$1;
